export const NAMED_SIZES_IN_ORDER = ["S", "M", "L", "XL"];
